import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PlatformPackagingSingleUnitResponse,
  PlatformPackagingUnit,
  PlatformPackagingUnitsResponse,
  UpdatePlatformPackagingUnit,
} from './platform-packaging-unit';

// Temporärer Workaround!
type DataWrapper = {
  data: CreateBenutzerNew;
};

type CreateBenutzerNew = {
  entity: PlatformPackagingUnit;
  statusCode: number;
  statusMessage: string;
};

@Injectable({ providedIn: 'root' })
export class PlatformPackagingUnitsService {
  private readonly baseApiPath = '/api/contentmanagement/platformpackagingunits';

  constructor(private readonly http: HttpClient) {}

  getAllPlatformPackagingUnits(params?: HttpParams): Observable<PlatformPackagingUnitsResponse> {
    return this.http.get<PlatformPackagingUnitsResponse>(`${this.baseApiPath}`, { params });
  }

  getPlatformPackagingUnit(shortName: string): Observable<PlatformPackagingSingleUnitResponse> {
    return this.http.get<PlatformPackagingSingleUnitResponse>(`${this.baseApiPath}/${shortName}`);
  }

  createUnit(unit: PlatformPackagingUnit): Observable<DataWrapper> {
    return this.http.post<DataWrapper>(`${this.baseApiPath}`, unit);
  }

  updateUnit(updateDto: UpdatePlatformPackagingUnit): Observable<void> {
    const { shortName, ...dto } = updateDto;
    return this.http.put<void>(`${this.baseApiPath}/${shortName}`, dto);
  }

  deleteUnit(shortName: string): Observable<void> {
    return this.http.delete<void>(`${this.baseApiPath}/${shortName}`);
  }
}
